var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"conversation-nav flex flex-row justify-start items-center gap-4"},[_c('li',[_c('router-link',{attrs:{"to":{
        name: 'conversation-details',
        params: { conversationId: _vm.conversation }
      },"exact":""}},[_vm._v(" Details ")])],1),_c('li',[_c('router-link',{attrs:{"to":{
        name: 'conversation-log',
        params: { conversationId: _vm.conversation }
      },"exact":""}},[_vm._v(" Log ")])],1),_c('li',[_c('router-link',{attrs:{"to":{
        name: 'conversation-upload',
        params: { conversationId: _vm.conversation }
      }}},[_vm._v(" Media ")])],1),_c('li',[_c('router-link',{attrs:{"to":{
        name: 'conversation-transcript',
        params: { conversationId: _vm.conversation }
      },"exact":""}},[_vm._v(" Transcript ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }